import { Text } from 'src/components/ui'
import { FetchModel } from 'src/services'
import { humanDateTime, prettyDateRange } from 'src/utility/time'

type Props = {
  model: FetchModel
}

export function TrainingPeriodLabel({ model }: Props): JSX.Element {
  const fromDate = model.activeTrainedModel?.dataStart || model.trainingStart
  const toDate = model.activeTrainedModel?.dataEnd || model.trainingEnd

  return (
    <div className="flex flex-col gap-xs">
      <div className="flex items-center gap-2xs">
        <Text bold>Training Period: </Text>
        <Text>
          {prettyDateRange({
            fromDate,
            toDate,
            timeInterval:
              fromDate && toDate ? 'range' : model.trainingPeriod || 'P1Y',
          })}
        </Text>
      </div>
      {model.trainingPeriodExclusions &&
        model.trainingPeriodExclusions.length > 0 && (
          <div className="flex flex-col gap-2xs">
            <Text bold>Excluded Periods:</Text>
            {model.trainingPeriodExclusions?.map((p, i) => (
              <div className="ml-xs flex items-center gap-xs" key={i}>
                <div className="size-xs rounded-full bg-icon" />
                <Text>
                  {`${humanDateTime(p.start)} - ${humanDateTime(p.end)}`}
                </Text>
              </div>
            ))}
          </div>
        )}
    </div>
  )
}
